import { gql } from "apollo-boost"

export const CreatePropose = gql`
mutation CreatePropose(
    $dateInit: String!,
    $dateEnd: String,
    $timeInit: String,
    $timeEnd: String,
    $location: String,
    $status: String!,
    $valueInit: String,
    $userPro: ID!,
    $userCli: ID!,
    $anunciosId: ID!,
    $description: String!){
  createPropose(
  dateInit: $dateInit
  dateEnd: $dateEnd
  timeInit: $timeInit
  timeEnd: $timeEnd
  status: $status
  location: $location
  valueInit: $valueInit
  fromId: $userCli
  toId: $userPro
  description: $description
  anunciosId: $anunciosId
  ){
id
anuncio {
  id
  skill {
    id
    name
  }
}
from {
      id
      name
      email
      phone
    }
    to {
      id
      name
      email
      phone
    }
}
}
`

// export const Proposes3 = gql`
// query($id: ID){
// user( id: $id ){
//   propoes(last: 3) {
//     id
//     valueInit
//     valueEnd
//     status
//     skill
//     location
//     dateInit
//     dateInitF
//     locationF
//     dateEnd
//     createdAt
//     anuncio {
//       id
//       skill {
//         id
//         name
//       }
//     }
//   }
//   proposesFrom(last: 3) {
//     id
//     valueInit
//     valueEnd
//     status
//     skill
//     dateInit
//     dateInitF
//     location
//     locationF
//     dateEnd
//     createdAt
//     anuncio {
//       id
//       skill {
//         id
//         name
//       }
//     }
//   }
// }
// }
// `

export const Proposes3 = gql`
query($id: ID!){
user( id: $id ){
  proposes {
    id
    valueInit
    valueEnd
    status
    location
    dateInit
    dateInitF
    locationF
    dateEnd
    createdAt
    anuncio {
      id
      skill {
        id
        name
      }
    }
  }
  proposesFrom {
    id
    valueInit
    valueEnd
    status
    dateInit
    dateInitF
    location
    locationF
    dateEnd
    createdAt
    anuncio {
      id
      skill {
        id
        name
      }
    }
  }
}
}
`

// export const ProposeCli = gql`
// query($id: ID){
// user( id: $id ){
//   proposesFrom (orderBy: date_DESC) {
//     id
//     valueInit
//     valueEnd
//     locationF
//     status
//     location
//     dateInit
//     createdAt
//     anuncio {
//       id
//       skill {
//         id
//         name
//       }
//     }
//   }
// }
// }
// `
export const ProposeCli = gql`
query($id: ID!){
user( id: $id ){
  proposesFrom {
    id
    valueInit
    valueEnd
    status
    dateInit
    location
    locationF
    createdAt
    anuncio {
      id
      skill {
        id
        name
      }
    }
  }
}
}
`

// export const ProposePro = gql`
// query($id: ID){
// user( id: $id ){
//   proposes (orderBy: id_DESC) {
//     id
//     valueInit
//     valueEnd
//     status
//     dateInit
//     location
//     locationF
//     createdAt
//     anuncio {
//       id
//       skill {
//         id
//         name
//       }
//     }
//   }
// }
// }
// `
export const ProposePro = gql`
query($id: ID!){
user( id: $id ){
  proposes {
    id
    valueInit
    valueEnd
    status
    dateInit
    location
    locationF
    createdAt
    anuncio {
      id
      skill {
        id
        name
      }
    }
  }
}
}
`

// export const ProposeAgenda = gql`
// query($id: ID!){
// user(id: $id){
//   proposes (orderBy: date_ASC){
//     id
//     valueInit
//     valueEnd
//     status
//     locationF
//     skill
//     dateInit
//     dateInitF
// anuncio {
//       id
//       skill {
//         id
//         name
//       }
//     }
//     dateEnd
//     location
//     dateEndF
//     timeEnd
//     timeEndF
//     timeInit
//     timeInitF
//     createdAt
//   }
//   proposesFrom (orderBy: date_ASC){
//     id
//     valueInit
//     valueEnd
//     status
//     skill
//     dateInit
//     dateInitF
//anuncio {
//       id
//       skill {
//         id
//         name
//       }
//     }
//     dateEnd
//     location
//     dateEndF
//     timeEnd
//     timeEndF
//     timeInit
//     timeInitF
//     createdAt
//   }
// }
// }
// `
export const ProposeAgenda = gql`
query($id: ID!){
user(id: $id){
  proposes {
    id
    valueInit
    valueEnd
    status
    locationF
    skill
    dateInit
    dateInitF
    anuncio {
      id
      skill {
        id
        name
      }
    }
    dateEnd
    location
    dateEndF
    timeEnd
    timeEndF
    timeInit
    timeInitF
    createdAt
  }
  proposesFrom {
    id
    valueInit
    valueEnd
    status
    skill
    dateInit
    dateInitF
    anuncio {
      id
      skill {
        id
        name
      }
    }
    dateEnd
    location
    dateEndF
    timeEnd
    timeEndF
    timeInit
    timeInitF
    createdAt
  }
}
}
`

export const ProposeId = gql`
query($id: ID!){
  propose( id: $id ){
    id
    createdAt
    dateEnd
    dateEndF
    dateInit
    locationF
    dateInitF
    location
    description
    aceite
    anuncio {
      id
      skill {
        id
        name
      }
    }
    from{
      id
      name
      email
      photo
      type
      phone
      address {
        state
        city
      }
    }
    status
    timeEnd
    timeEndF
    timeInit
    timeInitF
    to{
      id
      name
      email
      photo
      phone
      type
      address {
        state
        city
      }
    }
    valueEnd
    valueInit
    ranks {
      from {
        id
         name
      }
    }
  }
}
`

export const ChangeStatus = gql`
mutation ChangeStatus($id: ID!, $status: String){
  updatePropose(filter: {
    id: $id,
    status: $status}){
      createdAt
dateEnd
dateEndF
dateInit
dateInitF
description
locationF
id
skill
status
timeEnd
timeEndF
timeInit
    location
timeInitF
valueEnd
valueInit
aceite
from{
  id
    name
    birthday
    phone
    type
    email
    photo
    description
    address {
      city
      state
      street
      zipcode
      number
      complement
      neighborhood
      country
    }
}
to{
  id
    name
    birthday
    phone
    type
    email
    photo
    description
    address {
      city
      state
      street
      zipcode
      number
      complement
      neighborhood
      country
    }
}
chats{
  id
  description
  status
  from{
    id
  }
  to{
    id
  }
  propose {
    id
  }
}
  }
}
`

export const UpdatePropose = gql`
mutation UpdatePropose($id: ID!, $dateEndF: String, $dateInitF: String, $timeEndF: String,
$timeInitF: String, $valueEnd: String, $description: String){
  updatePropose(
    id: $id,
    dateEndF: $dateEndF,
    dateInitF: $dateInitF,
    timeEndF: $timeEndF,
timeInitF: $timeInitF,
valueEnd: $valueEnd,
description: $description
    ){
      createdAt
dateEnd
dateEndF
dateInit
dateInitF
description
id
locationF
status
timeEnd
timeEndF
timeInit
    location
timeInitF
valueEnd
valueInit
aceite
from{
  id
    name
    birthday
    phone
    type
    email
    avatar
    photo
    description
    skills
    address {
      city
      state
      street
      zipcode
      number
      complement
      neighborhood
      country
    }
}
to{
  id
    name
    birthday
    phone
    type
    email
    avatar
    photo
    description
    address {
      city
      state
      street
      zipcode
      number
      complement
      neighborhood
      country
    }
}
chats{
  id
  description
  status
  from{
    id
  }
  to{
    id
  }
  propose {
    id
  }
}
  }
}
`